import AnnualLeasingAmountError from './AnnualLeasingAmountError';
class InvalidAnnualLasingAmount extends AnnualLeasingAmountError {
    constructor(options) {
        super('INVALID_ANNUAL_LEASING_AMOUNT', options);
    }
}
export default InvalidAnnualLasingAmount;
